import { FooterButtonProps } from "../../common/FooterButton";

export interface FooterProps {
  nextButton?: FooterButtonProps;
  backButton?: FooterButtonProps;
}

export type StagedOrder = {
  id: string;
  orderNumberOrLoadoutGroupName: string;
  releaseNumber?: string;
  allOrderNumbers?: string[];
  requestedAmount: number;
  requiresTare: boolean;
  requiresGross: boolean;
  bayName?: string;
  tareScaleId?: string;
  grossScaleId?: string;
}

export enum ReceivingType {
  Loadpass = 'Loadpass',
  Scale = 'Scale',
  BulkReceiving = 'BulkReceiving',
}

export type StagedPurchaseOrder = {
  id: string;
  purchaseOrderNumber: string;
  requestedAmount: number;
  receivingType?: ReceivingType;
  requiresGross: boolean;
  bayName?: string;
  tareScaleId?: string;
  grossScaleId?: string;
}